export const roles = {
  Account_Read: 'Account.Read',
  Account_Write: 'Account.Write',
  Comm_List: 'Comm.List',
  Comm_Read: 'Comm.Read',
  Comm_Write: 'Comm.Write',
  Conf_Write: 'Conf.Write',
  Loy_Read: 'Loy.Read',
  Offer_List: 'Offer.List',
  Offer_Read: 'Offer.Read',
  Offer_Write: 'Offer.Write',
  Res_List: 'Res.List',
  Res_Read: 'Res.Read',
  Vouc_List: 'Vouc.List',
  Vouc_Read: 'Vouc.Read',
};